/** Page setup: auto-align and the time zone dates are shown in. */

import type { ReactNode } from 'react';

import { DEFAULT_SETTINGS } from './BuilderBar.tsx';
import type { DocumentSettings } from './reports-api.ts';

export function SetupPanel({
  settings,
  onSettings,
  onClose,
}: {
  settings: DocumentSettings;
  onSettings: (settings: DocumentSettings) => void;
  onClose: () => void;
}): ReactNode {
  return (
    <aside className="rs" aria-label="Page setup">
      <header className="rs-head">
        <strong>Page setup</strong>
        <button type="button" className="rb-icon" aria-label="Close" onClick={onClose}>
          ×
        </button>
      </header>
      <div className="rs-body">
        <label className="rs-check">
          <input
            type="checkbox"
            checked={settings.auto_align !== false}
            onChange={(event) => onSettings({ ...settings, auto_align: event.target.checked })}
          />
          Auto-align widgets (close gaps when something moves)
        </label>
        <p className="rs-explain">
          Widgets always snap to the 12-column grid and can never overlap.
        </p>
        <label className="rs-field">
          Time zone for dates
          <input
            value={settings.timezone ?? DEFAULT_SETTINGS.timezone}
            onChange={(event) => onSettings({ ...settings, timezone: event.target.value })}
          />
        </label>
      </div>
    </aside>
  );
}
